import usePageTranslation from "../../../hooks/ui/usePageTranslation";
import { sanitizeHtml } from '../../../util/sanitizeHtml';
import { useSelector } from "react-redux";
import { getPageByURL, getTranslatedText } from "../../../util/util";
import EditTranslationIcon from "../edit-translation-icon/EditTranslationIcon";
import { useLocation } from "react-router-dom";
import { useTheme } from "../../../theme/ThemeContext";

const Footer = () => {
  const {theme} = useTheme();
  const PageTranslation = usePageTranslation();
  const {TranslationEditFlag} = useSelector((state: any) => state.commonSlice);
  const location = useLocation();
  const footerPageName = getPageByURL(location.pathname);
  
  return (
    <>
    {(footerPageName === 'login' || footerPageName === 'eventLogin') ? null : (
      <footer className="">
        <div className="text-end p-5 me-5">
          {[
            theme?.aboutURL?.length > 0 && {
              url: theme.aboutURL,
              key: 'about.text'
            },
            theme?.contactURL?.length > 0 && {
              url: theme.contactURL,
              key: 'contact.text'
            },
            theme?.termsURL?.length > 0 && {
              url: theme.termsURL,
              key: 'terms.text'
            },
            theme?.privacyURL?.length > 0 && {
              url: theme.privacyURL,
              key: 'privacy.text'
            },
          ]
            .filter(Boolean)
            .map((item: any, index, arr) => (
              <span key={index}>
                <a
                  className="h6 text-decoration-none"
                  target="_blank"
                  rel="noopener noreferrer"
                  href={item.url}
                >
                  <span dangerouslySetInnerHTML={{ __html: sanitizeHtml(getTranslatedText(item.key, PageTranslation)) }} />
                </a>
                {TranslationEditFlag && <EditTranslationIcon translationKey={item.key} translationType='text'/>}
                {index < arr.length - 1 && " | "}
              </span>
            ))}
        </div>
        <div className="text-center mb-3">
          <small>
            {getTranslatedText('poweredByBlueCallom.text',PageTranslation)}
            {TranslationEditFlag && <EditTranslationIcon translationKey='poweredByBlueCallom.text' translationType='text'/>}
          </small>
        </div>
      </footer>
    )}
    </>
  )
}

export default Footer;